import React, { useState } from 'react';
import { adminAPI } from '../../lib/api';

const CreateUserForm = ({ onCreated }) => {
	const [showModal, setShowModal] = useState(false);
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [role, setRole] = useState('ADMIN');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		try {
			await adminAPI.createUser({ name, email, password, role });
			onCreated();
			setShowModal(false);
			setName('');
			setEmail('');
			setPassword('');
			setRole('ADMIN');
		} catch (err) {
			// Extract detailed error message
			const errorMessage = err.response?.data?.message
				|| err.response?.data?.error
				|| err.message
				|| 'Failed to create user';

			// Check for duplicate email error
			if (errorMessage.includes('duplicate key') || errorMessage.includes('already exists')) {
				setError(`Email "${email}" is already registered. Please use a different email address.`);
			} else {
				setError(errorMessage);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<button
				onClick={() => setShowModal(true)}
				className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
			>
				Create User
			</button>

			{showModal && (
				<div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
					<div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
						<div className="mt-3">
							<h3 className="text-lg font-medium text-gray-900 mb-4">Create New User</h3>

							{error && (
								<div className="mb-4 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg">
									<div className="flex items-start">
										<svg className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
											<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
										</svg>
										<div className="flex-1">
											<h4 className="text-sm font-semibold text-red-800 mb-1">Error Creating User</h4>
											<p className="text-sm text-red-700">{error}</p>
										</div>
									</div>
								</div>
							)}

							<form onSubmit={handleSubmit} className="space-y-4">
								<div>
									<label className="block text-sm font-medium text-gray-700">Name</label>
									<input
										type="text"
										value={name}
										onChange={(e) => setName(e.target.value)}
										required
										className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>

								<div>
									<label className="block text-sm font-medium text-gray-700">Email</label>
									<input
										type="email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										required
										className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>

								<div>
									<label className="block text-sm font-medium text-gray-700">Password</label>
									<input
										type="password"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										required
										className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>

								<div>
									<label className="block text-sm font-medium text-gray-700">Role</label>
									<select
										value={role}
										onChange={(e) => setRole(e.target.value)}
										className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
									>
										<option value="ADMIN">Admin</option>
										<option value="VIEWER">Viewer</option>
									</select>
									<p className="mt-1 text-xs text-gray-500">
										Note: Startups, Investors, Investor Networks, and Event Organizers should be created from their respective pages.
									</p>
								</div>

								<div className="flex justify-end gap-3 mt-6">
									<button
										type="button"
										onClick={() => setShowModal(false)}
										className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
									>
										Cancel
									</button>
									<button
										type="submit"
										disabled={loading}
										className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
									>
										{loading ? 'Creating...' : 'Create'}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default CreateUserForm;


